import api from './client';

export interface MentorSuggestion {
  id: number;
  publicId: string;
  userId: number;
  displayName: string | null;
  userPublicId: string;
  trustLevel: number;
  focusAreas: string[];
  bio: string | null;
  maxMentees: number;
  currentMenteeCount: number;
  totalMentorshipsCompleted: number;
  averageRating: number | null;
}

export const mentorAPI = {
  /** List all mentors visible to the current user (trust-filtered) */
  list: (params?: { search?: string; limit?: number; offset?: number }) =>
    api.get<{ success: boolean; data: MentorSuggestion[] }>('/mentors', { params }),

  /** Find mentors by focus area — used for contextual surfacing (Gap 4) */
  getByFocusArea: (area: string, limit?: number) =>
    api.get<{ success: boolean; data: MentorSuggestion[] }>('/mentors/by-focus', {
      params: { area, limit },
    }),
};
